








































































































































































































import axios from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { ProductSampleGroup, ProductSample, ProductSampleRequest } from '@/models/ProductSampleGroup';
import SingleSelect from '@/components/SingleSelect.vue';
import { websiteText } from '@/mixins/websiteTexts';

declare var grecaptcha: any;

@Component({
    components: {
        SingleSelect
    }
})
export default class ProductSampleForm extends Vue {
    [x: string]: any;
    private sampleGroups!: ProductSampleGroup[];
    protected selectedProducts: string[] = [];
    protected isLoaded: boolean = false;
    protected isSubmitted: boolean = false;
    protected isValid: boolean = true;
    protected firstName: string = '';
    protected lastName: string = '';
    protected organizationNumber: string = '';
    protected email: string = '';
    protected address: string = '';
    protected message: string = '';
    protected zipCode: string = '';
    protected city: string = '';
    protected country: string = '';
    protected phone: string = '';
    protected newsLetter: boolean = false;
    protected concentPolicy: boolean = false;
    protected concentPolicyMissing: boolean = false;
    private errorMsgs: string[] = [];
    private gdprTitle: string;
    private gdprText: '';
    private recaptchaString: string;
    private errors: { [key: string]: boolean } = {
        firstName: false,
        lastName: false,
        organizationNumber: false,
        phone: false,
        email: false,
        address: false,
        zipCode: false,
        city: false,
        country: false
    };

    constructor() {
        super();
        this.sampleGroups = JSON.parse(this.$attrs['data-sample-groups']);
        this.$attrs['data-sample-groups'] = '';
        this.gdprTitle = this.$attrs['data-gdpr-title'];
        this.gdprText = JSON.parse(this.$attrs['data-gdpr-text']);
        this.recaptchaString = this.$attrs['data-recaptcha-site-key'];
        this.$attrs['data-gdpr-text'] = '';
        this.$attrs['data-gdpr-title'] = '';
        this.$attrs['data-recaptcha-site-key'] = '';
    }

    private selectSampleGroup(i: number) {
        const temp = [...this.sampleGroups];
        temp[i].isOpen = !this.sampleGroups[i].isOpen;
        this.sampleGroups = temp;
    }
    private toggleError(group: ProductSampleGroup, i: number) {
        const temp = [...this.sampleGroups];
        temp[i].toggleError = !this.sampleGroups[i].toggleError;
        this.sampleGroups = temp;
    }
    private selectSample(e: Event, s: any, i: number) {
        const temp = [...this.sampleGroups];
        const selectedSample = temp[i].productSamples.find(x => x.id === s.id);
        if (selectedSample) {
            selectedSample.selected = (e.target as HTMLInputElement).checked;
        }
        this.sampleGroups = temp;
    }
    private clearError(fieldName: string) {
        this.errors[fieldName] = false;
    }

    private submitForm() {
        this.errorMsgs = [];
        const recaptchaSiteKey = this.recaptchaString; //(window as any).__litium.recaptchaSiteKey as string;

        if (!this.validateForm()) {
            return;
        } else {
            const submit = this.submit;
            grecaptcha.ready(function() {
                grecaptcha
                    .execute(recaptchaSiteKey, {
                        action: 'submit'
                    })
                    .then(function(token: string) {
                        submit(token);
                    });
            });
        }
    }

    private submit(token: string) {
        this.selectedProducts = [];
        this.sampleGroups.forEach(v => {
            v.productSamples
                .filter(x => x.selected)
                .forEach(vv => {
                    this.selectedProducts.push(vv.id);
                });
        });

        if (this.selectedProducts != null && this.selectedProducts.length > 0 && this.concentPolicy) {
            const request: ProductSampleRequest = {
                Token: token,
                Products: this.selectedProducts,
                FirstName: this.firstName,
                LastName: this.lastName,
                OrganizationNumber: this.organizationNumber,
                Mail: this.email,
                Phone: this.phone,
                Address: this.address,
                ZipCode: this.zipCode,
                City: this.city,
                Country: this.country,
                NewsLetter: this.newsLetter,
                ConcentPolicy: this.concentPolicy,
                Message: this.message
            };

            const requestContext = (window as any).__litium.requestContext;

            axios({
                method: 'post',
                url: `/api/productsample`,
                data: request,
                headers: {
                    'litium-request-context': JSON.stringify(requestContext)
                }
            })
                .then((response: any) => {
                    this.isSubmitted = true;
                    const self = this;
                    setTimeout(function() {
                        self.isLoaded = true;
                    }, 600);
                })
                .catch((response: any) => {
                    // handle error
                    // console.log(response);
                });
        } else if (!this.concentPolicy) {
            this.concentPolicyMissing = true;
        }
    }
    //animate
    private enter(element: HTMLElement) {
        const width = getComputedStyle(element).width;

        element.style.width = width;
        element.style.position = 'absolute';
        element.style.visibility = 'hidden';
        element.style.height = 'auto';

        const height = getComputedStyle(element).height;

        element.style.width = '';
        element.style.position = '';
        element.style.visibility = '';
        element.style.height = '0';
        getComputedStyle(element).height;
        requestAnimationFrame(() => {
            element.style.height = height;
        });
    }
    private afterEnter(element: HTMLElement) {
        element.style.height = 'auto';
    }
    private leave(element: HTMLElement) {
        const height = getComputedStyle(element).height;

        element.style.height = height;
        getComputedStyle(element).height;
        requestAnimationFrame(() => {
            element.style.height = '0';
        });
    }
    //end animate
    private numberOfArticles(samples: ProductSample[], onlySelected: boolean): number {
        if (onlySelected) return samples.filter(x => x.selected).length;
        return samples.length;
    }

    private validateForm(): boolean {
        const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

        var returnValue = true;

        if (this.firstName == '') {
            this.errorMsgs.push(websiteText('site.contactform.missingfirstname'));
            this.errors['firstName'] = true;
            returnValue = false;
        }
        if (this.lastName == '') {
            this.errorMsgs.push(websiteText('site.contactform.missinglastname'));
            this.errors['lastName'] = true;
            returnValue = false;
        }
        if (this.organizationNumber == '') {
            this.errorMsgs.push(websiteText('site.contactform.missinorganizationnumber'));
            this.errors['organizationNumber'] = true;
            returnValue = false;
        }
        if (this.email == '') {
            this.errorMsgs.push(websiteText('site.contactform.missingemail'));
            this.errors['email'] = true;
            returnValue = false;
        } else if (!reg.test(this.email)) {
            this.errorMsgs.push(websiteText('site.contactform.emailincorrect'));
            this.errors['email'] = true;
            returnValue = false;
        }
        if (this.phone == '') {
            this.errorMsgs.push(websiteText('site.contactform.missingphone'));
            this.errors['phone'] = true;
            returnValue = false;
        }
        if (this.address == '') {
            this.errorMsgs.push(websiteText('site.contactform.missingaddress'));
            this.errors['address'] = true;
            returnValue = false;
        }
        if (this.zipCode == '') {
            this.errorMsgs.push(websiteText('site.contactform.missingzipcode'));
            this.errors['zipCode'] = true;
            returnValue = false;
        }
        if (this.country == '') {
            this.errorMsgs.push(websiteText('site.contactform.missingcountry'));
            this.errors['country'] = true;
            returnValue = false;
        }
        if (this.city == '') {
            this.errorMsgs.push(websiteText('site.contactform.missingcity'));
            this.errors['city'] = true;
            returnValue = false;
        }

        return returnValue;
    }
}
